module.exports = __webpack_public_path__ + "img/beer-mug-empty.4b678662.svg";